import React from "react";
import styled from "styled-components";
import ReactPlayer from "react-player";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const PlayerModal = (props: {
  open: boolean;
  toggleModal: () => void;
  url?: string;
}) => {
  const { open, toggleModal, url } = props;

  return (
    <Modal
      open={open}
      onClose={toggleModal}
      styles={{
        modal: {
          maxWidth: "unset",
          width: "73%",
          padding: "unset",
        },
        overlay: {
          background: "rgba(0, 0, 0, 0.5)"
        },
        closeButton: {
          background: "white",
        },
      }}
      center
    >
      <StyledDiv className="player-wrapper">
        <ReactPlayer
          className="react-player"
          url={url}
          width="100%"
          height="100%"
          controls={true}
        />
      </StyledDiv>
    </Modal>
  );
};

const StyledDiv = styled.div`
  &:focus {
    outline: none;
  }

  & div, video {
    &:focus {
      outline: none;
    }
  }
`;

export default PlayerModal;
